import { AppType, AppTypeEnum, AvailableCities, Language, Municipal } from "./types";
import { ICatTypeV2, ILocation } from "../types";
import { CattownUser } from "./user";
import { APIPagesName } from "./hook/use-page-data";

interface IRelationshipCatCoordinate {
    type: ICatTypeV2;
    map_coordinate: { lat: number; lng: number; };
    image_url: string
}

type IStationScreenViewReplace = Partial<
    Record<APIPagesName, Record<Language, Record<number, string>>>
>;

const cattownUser = new CattownUser();

export const APP_TYPES: AppType[] = [AppTypeEnum.WEB, AppTypeEnum.ANDROID, AppTypeEnum.IOS];

export const MAP_COORDINATES: { [key: string]: ILocation } = {
    start: { lat: 46.496389, lng: 11.358056 },
    stationCommunication: { lat: 46.498333, lng: 11.350556 },
    stationRelationship: { lat: 46.502778, lng: 11.345556 },
    station4Fashion: { lat: 46.49722, lng: 11.348611 },
    station4Geek: { lat: 46.499722, lng: 11.349444 },
    station4Music: { lat: 46.495278, lng: 11.353611 },
    station4Sport: { lat: 46.503611, lng: 11.348889 },
    stationEnd: { lat: 46.493333, lng: 11.351944 },
}


export const googleMapsApiKey = 'AIzaSyDYr6og90erYaDg44db2OJ82-hbRZTVF7o'; // Replace with your Google Maps API Key

export const API_BASE_DOMAIN = 'https://app-cattown.com'

const STATION_RELATIONSHIP_CATS_COORDINATE_BOLZANO: IRelationshipCatCoordinate[] = [
    { type: 'fashion', map_coordinate: { lat: 46.50303219835328, lng: 11.34689435846201 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/FC_ltwr13.svg' },
    { type: 'music', map_coordinate: { lat: 46.503770, lng: 11.346195 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371673/MC_uqa3kg.svg' },
    { type: 'geek', map_coordinate: { lat: 46.502248, lng: 11.346666 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/GC_kdt5x7.svg' },
    { type: 'sport', map_coordinate: { lat: 46.5028259, lng: 11.3461897 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/SC_mrujyy.svg' }
]

const STATION_RELATIONSHIP_CATS_COORDINATE_BRESSANONE: IRelationshipCatCoordinate[] = [
    { type: 'fashion', map_coordinate: { lat: 46.715265371132915, lng: 11.654767000139856 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/FC_ltwr13.svg' },
    { type: 'music', map_coordinate: { lat: 46.7146632352825, lng: 11.654971238503947 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371673/MC_uqa3kg.svg' },
    { type: 'geek', map_coordinate: { lat: 46.71468564045807, lng: 11.654550507472948 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/GC_kdt5x7.svg' },
    { type: 'sport', map_coordinate: { lat: 46.71502171697014, lng: 11.65453416840387 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/SC_mrujyy.svg' }
]

const STATION_RELATIONSHIP_CATS_COORDINATE_MERANO: IRelationshipCatCoordinate[] = [
    { type: 'fashion', map_coordinate: { lat: 46.67018287334068, lng: 11.16270525950182 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/FC_ltwr13.svg' },
    { type: 'music', map_coordinate: { lat: 46.67015467630384, lng: 11.162360382381706 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371673/MC_uqa3kg.svg' },
    { type: 'geek', map_coordinate: { lat: 46.67018287334068, lng: 11.163124982295273 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/GC_kdt5x7.svg' },
    { type: 'sport', map_coordinate: { lat: 46.67006504990826, lng: 11.163211568466266 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/SC_mrujyy.svg' }
]

const STATION_RELATIONSHIP_CATS_COORDINATE_BRUNICO: IRelationshipCatCoordinate[] = [
    { type: 'fashion', map_coordinate: { lat: 46.79622904942718, lng: 11.934053363321482 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/FC_ltwr13.svg' },
    { type: 'music', map_coordinate: { lat: 46.79608852531476, lng: 11.934199210044653 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371673/MC_uqa3kg.svg' },
    { type: 'geek', map_coordinate: { lat: 46.79614954240853, lng: 11.933980439959413 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/GC_kdt5x7.svg' },
    { type: 'sport', map_coordinate: { lat: 46.79590177559683, lng: 11.934688066656179 }, image_url: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1753371672/SC_mrujyy.svg' }
]

export const STATION_RELATIONSHIP_CATS_COORDINATE_BY_CITY = {
    'bolzano': STATION_RELATIONSHIP_CATS_COORDINATE_BOLZANO,
    'merano': STATION_RELATIONSHIP_CATS_COORDINATE_MERANO,
    'bressanone': STATION_RELATIONSHIP_CATS_COORDINATE_BRESSANONE,
    'brunico': STATION_RELATIONSHIP_CATS_COORDINATE_BRUNICO
}

export function getStationRelationshipCatsCoordinate(city: AvailableCities | null = null) {
    city = city || cattownUser.getSelectedCity();
    return STATION_RELATIONSHIP_CATS_COORDINATE_BY_CITY[city];
}

export const FIVE_HOURS_MS = 1000 * 60 * 60 * 5;

export const REACT_QUERY_GC_TIME = FIVE_HOURS_MS;
export const REACT_QUERY_STALE_TIME = FIVE_HOURS_MS;


const STATION_SCREEN_VIEWS_REPLACE_MERANO: IStationScreenViewReplace = {
    [APIPagesName.STATION1_B]: {
        it: {
            2: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1762101322/screen-view-station-1-image-12-it-merano_vn0d4m.jpg'
        },
        de: {
            2: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1762101559/screen-view-station-1-image-12-de-merano_jvy2ac.jpg'
        },
        en: {
            2: 'https://res.cloudinary.com/dkedeajsu/image/upload/v1762101545/screen-view-station-1-image-12-en-merano_xrhup6.jpg'
        }
    },
    [APIPagesName.STATION_COMMUNICATION_A]: {
        it: { 0: 'https://cattown.it/img/station2/no_ghost/st2_1_mer.jpg' },
        de: { 0: 'https://cattown.it/img/station2/deutsch/no_ghost/st2_1_mer_deutsch.jpg' },
        en: { 0: 'https://cattown.it/img/station2/english/no_ghost/st2_1_merano_eng.jpg' }
    },
    [APIPagesName.STATION_COMMUNICATION_B]: {
        it: {
            0: 'https://cattown.it/img/station2/no_ghost/st2_8_mer.jpg',
            2: 'https://cattown.it/img/station2/no_ghost/st2_10_mer.jpg'
        },
        de: {
            0: 'https://cattown.it/img/station2/deutsch/no_ghost/st2_8_mer_deutsch.jpg',
            2: 'https://cattown.it/img/station2/deutsch/no_ghost/st2_10_mer_deutsch.jpg'
        },
        en: {
            0: 'https://cattown.it/img/station2/english/no_ghost/st2_8_mer_eng.jpg',
            2: 'https://cattown.it/img/station2/english/no_ghost/st2_10_mer_eng.jpg'
        }
    }
}

const STATION_SCREEN_VIEWS_REPLACE_BRUNICO: IStationScreenViewReplace = {
    [APIPagesName.STATION_COMMUNICATION_B]: {
        it: {
            0: 'https://cattown.it/img/station2/no_ghost/st2_8_brun.jpg',
            2: 'https://cattown.it/img/station2/no_ghost/st2_10_brun.jpg'
        },
        de: {
            0: 'https://cattown.it/img/station2/deutsch/no_ghost/st2_8_brun_deutsch.jpg',
            2: 'https://cattown.it/img/station2/deutsch/no_ghost/st2_10_brun_deutsch.jpg'
        },
        en: {
            0: 'https://cattown.it/img/station2/english/no_ghost/st2_8_brun_eng.jpg',
            2: 'https://cattown.it/img/station2/english/no_ghost/st2_10_brun_eng.jpg'
        }
    }
}

const STATION_SCREEN_VIEWS_REPLACE_MEBRESSANONE: IStationScreenViewReplace = {
    [APIPagesName.STATION_COMMUNICATION_B]: {
        it: {
            0: 'https://cattown.it/img/station2/no_ghost/st2_8_bress.jpg',
            2: 'https://cattown.it/img/station2/no_ghost/st2_10_bress.jpg'
        },
        de: {
            0: 'https://cattown.it/img/station2/deutsch/no_ghost/st2_10_bress_deutsch.jpg',
            2: 'https://cattown.it/img/station2/deutsch/no_ghost/st2_10_bress_deutsch.jpg'
        },
        en: {
            0: 'https://cattown.it/img/station2/english/no_ghost/st2_8_bress_eng.jpg',
            2: 'https://cattown.it/img/station2/english/no_ghost/st2_10_bress_eng.jpg'
        }
    }
}

export const STATION_SCREEN_VIEWS_REPLACE_BY_CITY: Partial<Record<Municipal, IStationScreenViewReplace>> = {
    merano: STATION_SCREEN_VIEWS_REPLACE_MERANO,
    brunico: STATION_SCREEN_VIEWS_REPLACE_BRUNICO,
    bressanone: STATION_SCREEN_VIEWS_REPLACE_MEBRESSANONE,
}